import { ENTITY_TYPES } from '@sales-center/common'
import {
  clearedFilters,
  ILead,
  LeadFilterSet,
  selectLeadFilters,
  useSaveLeadFilters,
} from '@user/store/lead'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { FilterChipListWrapper } from '../Filters/FilterChip'

export function LeadPageFilterChipList() {
  const saveLeadFilters = useSaveLeadFilters()
  const { filterSet } = useSelector(selectLeadFilters)

  return (
    <FilterChipListWrapper<ILead, LeadFilterSet>
      applyCallback={saveLeadFilters}
      clearedFilters={clearedFilters}
      filterSet={filterSet}
      entityType={ENTITY_TYPES.Lead}
    />
  )
}
